import React from 'react';
import { useActions, useValues } from 'kea';

import RemoveDialog from './RemoveDialog';
import alertlogic from 'src/store/alert';

const ActionButtons = ({ row, index }) => {
	const { remove_one } = useActions(alertlogic);

	const handle_remove = () => {
		remove_one(row._id, row.vehicles[index].vehicle._id);
		row.vehicles.splice(index, 1);
	}

	return (
		<div style={{ display: 'flex', flexGrow: 1, justifyContent: 'flex-end' }}>
			{/* <EditDialog alert={row} index={index} OnEdit={handle_edit} /> */}
			<RemoveDialog OnRemove={handle_remove} />
		</div>
	);
};

export default ActionButtons;
